import { render, staticRenderFns } from "./CategoryBlock.vue?vue&type=template&id=3f59f2bd&"
import script from "./CategoryBlock.vue?vue&type=script&lang=js&"
export * from "./CategoryBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports